import { withRouter, WithRouterProps } from 'app/components/enhancers/with-router';
import * as React from 'react';
import { Favourite } from './favourite';
import { FavouriteInstance } from './favourite-context';
import { Case } from 'app/area/case';
import { CaseViewModal } from 'app/area/case/components/case-view-modal/case-view-modal';
import { Outlet, useOutletContext } from 'react-router-dom';

interface FavouriteRouteProps {
  location: { query: { report: string; openFilters?: string; editSavedFavourite?: string }};
  params: { favouriteId: string };
}

export function FavouriteRoute(props: FavouriteRouteProps & WithRouterProps) {
  
  const { params, router: { location: { query } } } = props;

  const report = query?.report ?
    parseInt(query.report, 10) :
    undefined;
  
  const favouriteId = params?.favouriteId && parseInt(params.favouriteId, 10);

  const intiallyOpenFilter = Boolean(query?.openFilters);

  const editSavedFavourite = Boolean(query?.editSavedFavourite);

  return (
    <FavouriteInstance>
      <Favourite
        editSavedFavourite={editSavedFavourite}
        initiallyOpenFilter={intiallyOpenFilter}
        overrideReport={report}
        favouriteId={favouriteId}
      />
      <Outlet context={{ favouriteId: favouriteId }} />
    </FavouriteInstance>
  );
}

export const FavouriteCaseViewModal = () => {
  const CaseWithRouter = withRouter(Case);
  const { favouriteId } = useOutletContext<{ favouriteId: number }>();
  return (
    <CaseViewModal children={<CaseWithRouter />} favouriteId={favouriteId} />
  );
};
